import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, Sparkles } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function WhatYouGet() {
  const items = [{
    title: 'El Manual Maestro del Sistema "Base + 3"',
    desc: 'La metodología exacta para cocinar una sola vez y no volver a tocar una olla pesada en toda la semana.'
  }, {
    title: 'Capítulo de la Base Pollo Universal',
    desc: 'Cómo lograr el desmenuzado perfecto en 18 minutos y sus 3 transformaciones (Tacos, Sopa y Wraps).'
  }, {
    title: 'Capítulo de la Carne Molida Mágica',
    desc: 'El secreto de la cocción neutra para saltar de una Pasta Boloñesa a un Arroz Frito Oriental en un abrir y cerrar de ojos.'
  }, {
    title: 'Capítulo de Frijoles en Minutos',
    desc: 'La guía de supervivencia económica para cenas nutritivas de $5 dólares que tus hijos amarán.'
  }, {
    title: 'Módulo Snacks "SOS"',
    desc: '3 salvavidas de 5 minutos (Manzanas Nachos, Pinchos de Queso y Yogur Bark) para matar el hambre antes de la cena sin arruinar el apetito.',
    isNew: true
  }, {
    title: 'Guía de Planificación Dominical de 10 Minutos',
    desc: 'El sistema de "Lista Maestra" para que tu compra del súper sea quirúrgica y rápida. Nada de pasear por los pasillos sin saber qué llevar.',
    isNew: true
  }, {
    title: 'Recetario de Postres Express en 3 Minutos',
    desc: '3 opciones dulces y saludables para el microondas (Mousse de Chocolate, Plátano Split y Galleta de Taza) para premiarte al final del día.',
    isNew: true
  }, {
    title: 'Checklist de Despensa "Los 10 de Siempre"',
    desc: 'Los ingredientes que garantizan que, pase lo que pase, siempre habrá algo rico en la mesa.'
  }];
  return <Section bg="white" data-id="element-216">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-[#422006]" data-id="element-217">
        Lo que obtienes hoy
      </h2>

      <div className="grid gap-6 mb-12" data-id="element-218">
        {items.map((item, idx) => <div key={idx} className="flex gap-4 p-6 bg-[#FFF8F0] rounded-2xl border border-[#F59E0B]/10 hover:border-[#F59E0B]/30 transition-colors" data-id="element-219">
            <CheckCircle2 className="text-[#EA580C] shrink-0 mt-1" size={28} data-id="element-220" />
            <div data-id="element-221">
              <h3 className="text-xl font-bold text-[#422006] mb-2 flex items-center flex-wrap gap-2" data-id="element-222">
                {item.title}
                {item.isNew && <span className="inline-flex items-center gap-1 bg-[#F59E0B] text-white text-xs font-bold px-2 py-1 rounded-full uppercase tracking-wider" data-id="element-223">
                    <Sparkles size={12} data-id="element-224" /> Nuevo
                  </span>}
              </h3>
              <p className="text-[#78350F] leading-relaxed" data-id="element-225">{item.desc}</p>
            </div>
          </div>)}
      </div>

      <div className="text-center" data-id="element-226">
        <CTAButton data-id="element-227" />
      </div>
    </Section>;
}